VjsAdmin.WebinarUpdates = (function () {
    const $vjsTable = $('#vjs-webinars-table');
    const $jrTable = $('#jr-webinars-table');

    const init = function () {
        initVJSTable();
        initJRTable();
        $('.update-webinar-data').on('click', updateWebinarData);
    };

    function updateWebinarData(e) {
        const webinarAccount = $(e.target).data('account');
        $.ajax({
            url: Slim.Router.pathFor('sales.webinar.update.data'),
            dataType: 'text',
            method: 'GET',
            data: {
                account: webinarAccount,
            },
            async: true,
        })
            .done((responseData) => {
                window.location.href = responseData;
            })
            .fail((textStatus, errorThrown) => {
                console.log('FAIL', textStatus, errorThrown);
            })
            .always(() => {});
    }
    const initVJSTable = function () {
        $('#vjs-account-filter').on('change', () => {
            const valSelected = $('#vjs-account-filter option:selected').val();
            if ($('#vjs-account-filter option:selected').val() !== '') {
                switch (valSelected) {
                    case 'sales':
                        $vjsTable.bootstrapTable('filterBy', {
                            account: ['sales'],
                        });
                        break;
                    case 'customer_service':
                        $vjsTable.bootstrapTable('filterBy', {
                            account: ['customer_service'],
                        });
                        break;
                    default:
                        $vjsTable.bootstrapTable('filterBy', {});
                }
            }
        });
        $vjsTable.bootstrapTable({
            ...VjsTable.simpleTableDefaults(),
            table: '#vjs-webinars-table',
            formatNoMatches() {
                return 'No webinars in database';
            },
            idField: 'id',
            sortName: 'subject',
            search: false,
            pagination: true,
            showColumns: true,
            sidePagination: 'client',
            url: Slim.Router.pathFor('sales.webinar.webinars.vjs'),
            columns: [
                {
                    title: 'Subject',
                    field: 'subject',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Description',
                    field: 'description',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Start Time',
                    field: 'start_time',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: 'End Time',
                    field: 'end_time',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: 'Date',
                    field: 'date',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Account',
                    field: 'account',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter(value, row) {
                        switch (row.account) {
                            case 'customer_service':
                                return 'Customer Service';
                            default:
                                return row.account.substr(0, 1).toUpperCase() + row.account.substr(1);
                        }
                    },
                },
                {
                    title: 'Link',
                    field: 'registration_url',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    formatter(value, row) {
                        return value
                            ? `Webinar Registration <a href='${row.registration_url}' target='_blank'><i class='fa fa-external-link'></i></a>`
                            : "Webinar Registration <i class='fa fa-times text-danger'></i>";
                    },
                },
            ],
            responseHandler(res) {
                return {
                    rows: res.data ? res.data : [],
                };
            },
        });
    };
    const initJRTable = function () {
        $('#jr-account-filter').on('change', () => {
            const valSelected = $('#jr-account-filter option:selected').val();
            if ($('#jr-account-filter option:selected').val() !== '') {
                switch (valSelected) {
                    case 'sales':
                        $jrTable.bootstrapTable('filterBy', {
                            account: ['sales'],
                        });
                        break;
                    case 'customer_service':
                        $jrTable.bootstrapTable('filterBy', {
                            account: ['customer_service'],
                        });
                        break;
                    default:
                        $jrTable.bootstrapTable('filterBy', {});
                }
            }
        });

        $jrTable.bootstrapTable({
            ...VjsTable.simpleTableDefaults(),
            table: '#jr-webinars-table',
            formatNoMatches() {
                return 'No webinars in database';
            },
            idField: 'id',
            sortName: 'subject',
            search: false,
            pagination: true,
            showColumns: true,
            sidePagination: 'client',
            url: Slim.Router.pathFor('sales.webinar.webinars.jr'),
            columns: [
                {
                    title: 'Subject',
                    field: 'subject',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Description',
                    field: 'description',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Start Time',
                    field: 'start_time',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'End Time',
                    field: 'end_time',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Date',
                    field: 'date',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Account',
                    field: 'account',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter(value, row) {
                        switch (row.account) {
                            case 'customer_service':
                                return 'Customer Service';
                            default:
                                return row.account.substr(0, 1).toUpperCase() + row.account.substr(1);
                        }
                    },
                },
                {
                    title: 'Link',
                    field: 'registration_url',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter(value, row) {
                        return value
                            ? `Webinar Registration <a href='${row.registration_url}' target='_blank'><i class='fa fa-external-link'></i></a>`
                            : "Webinar Registration <i class='fa fa-times text-danger'></i>";
                    },
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.rows = res.data && res.data[0] ? res.data[0] : [];
                return formattedResult;
            },
        });
    };
    return {
        init,
    };
}());
